import React, { useState, useEffect, Fragment } from "react"
import { Link, navigate } from "gatsby"
import VideoPlayer from '../videoplayer/videoplayer';

import { GoClock, GrPlayFill } from "react-icons/all"
// import ModalVideo from "react-modal-video"

import IconArrow from "../../images/Icons/icon_arrow2.svg"
import IconPdf from "../../images/Icons/icon_pdf.svg"

import * as styles from "./postFull.module.scss"
import { element } from "prop-types";


const PostFull = ({ item, lessonAfterCurrent, lessonBeforeCurrent, reset }) => {

    return (
        <div className={ item.video_url != '' ? styles.postFull : styles.postFull_no_video}>
            
            
            <div>
                <div className={styles.content}>
                    <p className="{}">{item.point} {item.label}</p>
                    <h3 style={{ marginTop: "20px", marginBottom: "20px" }}>
                        {item.title}
                    </h3>
                    <div className=""> {item.description} </div>

                    <p style={{ display: "flex", alignItems: "center" }}>

                        {item.video_url != '' &&
                            <Fragment>
                                <GoClock style={{ marginRight: "5px" }} />
                                {item.duration} min
                            </Fragment>
                        }
                        
          </p>
                </div>
                {item.file_url !== '' &&
                    <Link to={item.file_url} target={'_blank'} className={styles.document}>
                        {item.file_title || 'PDF herunterladen'}
                        <IconPdf />
                    </Link>
                }
            </div>

            <VideoPlayer
                url={item.video_url}
                id={item.point}
                img={item.image_url}
                secondsProgressInLocalStorage={true}
            />


            {/* </div> */}
            <div className={styles.navigation}>
                <Link onClick={() => reset()} to={`/modules/${lessonBeforeCurrent.id}`} className={styles.prev} style={lessonBeforeCurrent != '' ? { display: 'block' } : { visibility: 'hidden' }} >
                    <IconArrow />
                </Link>
                <Link onClick={reset} to={`/modules/${lessonAfterCurrent.id}`} className={styles.next} style={lessonAfterCurrent != '' ? { display: 'block' } : { visibility: 'hidden' }}>
                    <IconArrow />
                </Link>
            </div>
        </div >
    )
}

export default PostFull
